import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { isAuthenticated, userData } from "../store";

const LoadingIndicator = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <p>Loading...</p>
  </div>
);

const PrivateRoute = ({ child }) => {
  const userAuthenticated = useRecoilValue(isAuthenticated);
  const userInfo = useRecoilValue(userData);
  const navigate = useNavigate();
  let location = useLocation();

  useEffect(() => {
    // Only run navigation logic if userInfo exists and has ID
    if (!userInfo?.ID) return;

    if (userInfo?.userRole === "Landlord" && userInfo.surveyStatus === false) {
      navigate("/survey");
    } else if (
      userInfo?.isSubscribed === false &&
      userInfo?.subscriptionStatus === "" &&
      userInfo?.userRole !== "Property Manager"
    ) {
      navigate("/subscription");
    } else if (
      userInfo?.isSubscribed === false &&
      userInfo?.subscriptionStatus === "Cancelled" &&
      userInfo?.isPaymentFailed === false &&
      userInfo?.userRole !== "Property Manager"
    ) {
      navigate("/subscription/retry");
    } else if (
      userInfo?.isSubscribed === false &&
      userInfo?.subscriptionStatus === "Cancelled" &&
      userInfo?.isPaymentFailed === true &&
      userInfo?.userRole !== "Property Manager"
    ) {
      navigate("/subscription/Details");
    }
  }, [userInfo, location.pathname, navigate]);

  // If not authenticated and no user data, redirect to login (handles session expiry / idle logout)
  if (!userAuthenticated && (!userInfo || !userInfo.ID)) {
    return <Navigate to="/login" replace={true} />;
  }

  // Brief loading state while recoil-persist hydrates but auth is still pending
  if (!userInfo || !userInfo.ID) {
    return <LoadingIndicator />;
  }

  return userAuthenticated ? child : <Navigate to="/login" replace={true} />;
};

export default PrivateRoute;
